/**
 * SkipLink — the first focusable element in the application shell (PROD-UX-076 / FULL-0162).
 *
 * Every page sits behind the same ~40-link sidebar. A keyboard or switch user had to tab through
 * the entire navigation before reaching the ticket, employee, approval or admin surface they came
 * for. This link is visually hidden until focused and jumps to `<main id="main-content">`, which is
 * `tabIndex={-1}` so the browser moves focus there rather than only scrolling.
 *
 * It is same-page navigation only: it adds no route, fetches nothing and grants nothing.
 */
import { SKIP_LINK_CLS } from "../designSystem/designTokens";

export const MAIN_CONTENT_ID = "main-content";
export const SKIP_LINK_TEXT = "דלג לתוכן הראשי";

export default function SkipLink({ targetId = MAIN_CONTENT_ID }) {
  return (
    <a href={`#${targetId}`} className={SKIP_LINK_CLS} data-testid="skip-link">
      {SKIP_LINK_TEXT}
    </a>
  );
}
